import { render, staticRenderFns } from "./InstrumentForm.vue?vue&type=template&id=517de986&scoped=true"
import script from "./InstrumentForm.vue?vue&type=script&lang=ts"
export * from "./InstrumentForm.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentForm.vue?vue&type=style&index=0&id=517de986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517de986",
  null
  
)

export default component.exports